import type { EChartsOption, TooltipComponentOption } from 'echarts';

/**
 * Garante que tooltips escapem de ancestrais com `overflow: hidden`
 * (ex.: `.chart-card-viewport`, cards arredondados).
 */
function patchTooltip(tooltip: TooltipComponentOption): TooltipComponentOption {
  if (tooltip.appendTo != null || tooltip.appendToBody) return tooltip;
  return {
    ...tooltip,
    appendTo: 'body',
    confine: false,
  };
}

export function withBodyTooltips(options: EChartsOption): EChartsOption {
  if (!options.tooltip) return options;
  if (Array.isArray(options.tooltip)) {
    return { ...options, tooltip: options.tooltip.map(patchTooltip) };
  }
  return { ...options, tooltip: patchTooltip(options.tooltip) };
}
